import React from 'react';
import { Link } from 'react-router-dom';
import { ScrollToTop } from 'react-simple-scroll-up';
import 'bootstrap/dist/js/bootstrap.min.js';

const Footer = () => {
    return (
        <div>
            {/* Contact Section */}
            <section className="contac">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 plr-0">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.874094519268!2d73.91589801530768!3d18.444024876323557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2ea34a1486fa7%3A0xf812258592a75c85!2s4%2C%202%2C%20Wadachi%20Wadi%20Rd%2C%20Shree%20Siddhivinayak%20Meera%2C%20Undri%2C%20Pune%2C%20Maharashtra%20412308!5e0!3m2!1sen!2sin!4v1573477765006!5m2!1sen!2sin"
                                width="100%" height="250" frameBorder="0" style={{ border: 0 }} allowFullScreen=""
                            ></iframe>
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 plr-0">
                            <div className="contactBg">
                                <ul className="socialArea">
                                    <li><i className="fa fa-map-marker"></i> <span> Address </span> Sr. No. 4/2 Wadachi Wadi, Autadewadi Road, Near Kamal Plastic - Undri, Pune - 411028. </li>
                                    <li><i className="fa fa-phone"></i> <span> Phone </span> +91 7030332900 / 7030272900 </li>
                                    <li><i className="fa fa-envelope-o"></i> <span> Email </span> hr@adberinfra.co.in / admin@adberinfra.co.in </li>
                                </ul>
                                <div className="contactsec">
                                    <h6> Contact Us </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer Section */}
            <section className="footlinks">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <ul className="socialArea">
                                <li><Link to="/"> Home </Link></li>
                                <li><Link to="/about-us"> About Us </Link></li>
                                <li><Link to="/services"> Services </Link></li>
                                <li><Link to="/clients"> Clients </Link></li>
                                <li><Link to="/career"> Career </Link></li>
                                <li><Link to="/contact-us"> Contact Us </Link></li>
                            </ul>
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <p> © 2020 | Design by <a href="https://sailotechnosoft.com/" target="_blank" rel="noopener noreferrer"> Sailo Technosoft</a></p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Contact Button */}
            <div className="contactBtn">
                <Link to="/contact-us"> Contact </Link>
            </div>

            {/* Social Icons */}
            <ul className="Socialicons">
                <a href="https://www.facebook.com/Adberinfra/" title="Facebook" className="facebook" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                <a href=" " title="Twitter" className="twitter"><i className="fa fa-twitter" aria-hidden="true"></i></a>
                <a href=" " title="Youtube" className="youtube"><i className="fa fa-youtube-play" aria-hidden="true"></i></a>
            </ul>
            {/* ... */}
            <ScrollToTop />
        </div>
    );
}

export default Footer;
